import { useEffect, useLayoutEffect, useRef } from 'react';

export function useBFCache(onRestore) {
  const onRestoreRef = useRef(onRestore);

  useLayoutEffect(() => {
    onRestoreRef.current = onRestore;
  }, [onRestore]);

  useEffect(() => {
    const handlePageShow = event => {
      if (event.persisted) {
        onRestoreRef.current(event);
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
}
